import { useState } from 'react';

interface MealGalleryProps {
  mainImage: string;
  galleryImages: string[];
  name: string;
}

export default function MealGallery({ mainImage, galleryImages, name }: MealGalleryProps) {
  const [activeImage, setActiveImage] = useState(mainImage);

  const allImages = [mainImage, ...galleryImages];

  return (
    <div className="flex flex-col gap-4">
      {/* Main Image */}
      <div className="w-full h-96 rounded-2xl overflow-hidden shadow-lg">
        <img
          src={activeImage}
          alt={name}
          className="w-full h-full object-cover transition-all duration-500"
        />
      </div>

      {/* Thumbnails */}
      <div className="flex gap-3">
        {allImages.map((img, index) => (
          <button
            key={index}
            onClick={() => setActiveImage(img)}
            className={`w-20 h-20 rounded-xl overflow-hidden flex-shrink-0 border-2 transition-all cursor-pointer ${
              activeImage === img ? 'border-primary-500 scale-105' : 'border-transparent hover:border-primary-300'
            }`}
          >
            <img src={img} alt={`${name} view ${index + 1}`} className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
}
